import { render, staticRenderFns } from "./ContainerContentType.vue?vue&type=template&id=4b23130b&scoped=true"
import script from "./ContainerContentType.vue?vue&type=script&lang=js"
export * from "./ContainerContentType.vue?vue&type=script&lang=js"
import style0 from "./ContainerContentType.vue?vue&type=style&index=0&id=4b23130b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b23130b",
  null
  
)

export default component.exports